import {BasePopupProps} from "../../Models";
import {useState} from "react";
import {WindowActionsBar} from "@progress/kendo-react-dialogs";
import FlintButton from "@components/controls/FlintButton";
import {useTranslation} from "react-i18next";
import {Error} from "@progress/kendo-react-labels";
import FlintEditor from "@components/controls/FlintEditor";

export default function EditorInputDialog(props: EditorInputDialogProps) {
    const {state, handlers, validators} = useEditorInputDialog(props);
    const {t} = useTranslation();

    return (
        <div className="text-area-popup">
            {props.description && (
                <div className="mb-2" dangerouslySetInnerHTML={{__html: props.description}} />
            )}

            <div className="form-group mb-4">
                <FlintEditor
                    contentStyle={{minHeight:"250px"}}
                    useSimpleToolbox={true}
                    value={state.message.get}
                    onChange={(e) => handlers.handleMessageChanged(e.html)}
                />
                {validators.validationMessage && <Error>{validators.validationMessage}</Error>}
            </div>

            <WindowActionsBar layout="stretched">
                <FlintButton themeColor="secondary" onClick={handlers.handleCancelled}>
                    {t("Cancel")}
                </FlintButton>
                <FlintButton themeColor="primary" onClick={handlers.handleConfirmed}>
                    {t("Confirm")}
                </FlintButton>
            </WindowActionsBar>
        </div>
    );
}

export interface EditorInputDialogProps extends BasePopupProps<string> {
    description?: string;
    InitialValue?: string;
    Required?: boolean; // 🔹 optionally enforce validation
}

function useEditorInputDialog(props: EditorInputDialogProps) {
    const [message, setMessage] = useState<string>(props.InitialValue || "");
    const [validationMessage, setValidationMessage] = useState<string>("");

    function isEmpty(html: string) {
        const clean = html.trim();
        return clean === "" || clean === "<p></p>";
    }

    function handleCancelled() {
        props.OnCancelled();
    }

    function handleConfirmed() {
        if (props.Required && isEmpty(message)) {
            setValidationMessage("Field is required");
            return;
        }
        props.OnConfirmedAndSaved(message);
    }

    function handleMessageChanged(html: string) {
        if (props.Required && isEmpty(html)) {
            setValidationMessage("Field is required");
        } else {
            setValidationMessage("");
        }
        setMessage(html);
    }

    return {
        state: {
            message: {get: message, set: setMessage},
        },
        handlers: {
            handleConfirmed,
            handleCancelled,
            handleMessageChanged,
        },
        validators: {
            validationMessage,
        },
    };
}
